import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'url': '',
  'loading': false,
};

export const dowloadHappyWait = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.DOWNLOADING_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DOWNLOADED_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.excel,
    }),
    [ActionTypes.DOWNLOADED_WAIT_HAPPY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAR_DOWNLOADED_WAIT_HAPPY]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
